import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
  showGlobalError,
  hideGlobalError,
} from 'common/redux/errors/errorsSlice';
import { AUTO_SAVE_IDLE_ERROR, AUTO_SAVE_LOCK_ERROR } from './constants';

type Props = {
  containerId: string;
  metadata?: {
    bannerMetadata: {
      alertLevel: string;
      bannerPosition: string;
    };
  };
  userName?: string;
};

interface LocationState {
  autoSaveError:
    | typeof AUTO_SAVE_IDLE_ERROR
    | typeof AUTO_SAVE_LOCK_ERROR
    | null;
}

const useGlobalError = ({ containerId, metadata, userName }: Props) => {
  const dispatch = useDispatch();
  const location = useLocation<LocationState>();
  const { state: { autoSaveError } = {} } = location;
  useEffect(() => {
    if (autoSaveError) {
      window.history.replaceState({ autoSaveError }, '');
      dispatch(
        showGlobalError({
          eventType: 'banner',
          id: containerId,
          error: { code: autoSaveError },
          metadata,
          userName,
        })
      );
    }
    return () => {
      dispatch(hideGlobalError());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoSaveError, containerId, userName]);
  return null;
};
export default useGlobalError;
